import React from 'react';
import {
  SvgContainer,
  SvgContainerProps
} from '@/components/icon/SvgContainer';
import { Priority, priorityColors } from '@/modules/surgicalEvent';

type PriorityFlagIconProps = SvgContainerProps & {
  priority?: Priority;
};

export const PriorityFlagIcon = ({
  priority,
  ...props
}: PriorityFlagIconProps) => (
  <SvgContainer
    fill={
      priority && priority !== Priority.NOT_APPLICABLE
        ? priorityColors[priority]['500']
        : 'none'
    }
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke={priorityColors[priority || Priority.NOT_APPLICABLE]['500']}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
    />
  </SvgContainer>
);
